import { useRedeemPassword } from "@/api/auth";
import InventoZen from "@/components/icons/InventoZen.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

interface UpdatePasswordProps {
  onNext: () => void;
}

const UpdatePassword = ({ onNext }: UpdatePasswordProps) => {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const { mutate: redeemPassword } = useRedeemPassword();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return;
    if (!email) return;
    redeemPassword(
      {
        user: {
          email: email,
          password: newPassword,
          confirm_password: confirmPassword,
        },
        token: token,
      },
      {
        onSuccess: () => {
          onNext();
        },
      },
    );
  };

  return (
    <div className="h-full flex items-center justify-center">
      <div className="m-auto w-[500px] h-fit p-10 bg-white rounded-lg shadow border border-slate-200 flex-col justify-start items-center gap-8 inline-flex">
        <div>
          <div className="justify-center items-center flex">
            <InventoZen />
          </div>
          <p className="text-center text-slate-900 text-3xl font-semibold font-['Instrument Sans']">
            {t("resetYourPassword")}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="w-full grid gap-4">
          <Input
            label={t("password")}
            id="password"
            type="password"
            placeholder={t("password")}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Input
            label={t("passwordConfirmation")}
            id="confirmPassword"
            type="password"
            placeholder={t("passwordConfirmation")}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <div className="flex flex-col">
            <Button
              type="submit"
              variant="ghost"
              className="mt-8 h-12 px-4 py-3 bg-[#008bd4] rounded-lg border border-[#006eab] justify-center items-center gap-1.5 inline-flex"
            >
              <div className="px-0.5 justify-center items-center flex">
                <p className="text-white text-base font-semibold font-['Raleway'] leading-normal">
                  {t("resetPassword")}
                </p>
              </div>
            </Button>
            <a
              href="/"
              className="text-[#005d8d] text-sm font-semibold font-['Raleway'] text-center leading-normal mt-6"
            >
              {t("returnToLogin")}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdatePassword;
